import { netflexCdnUrlPlugin as D } from "@apility/vue-netflex-cdn-url";
import { useCdnUrl as J } from "@apility/vue-netflex-cdn-url";
import { breakpointsPlugin as z } from "@apility/vue-breakpoints-plugin";
import { useBreakpoints as T } from "@apility/vue-breakpoints-plugin";
import { inject as S, defineComponent as y, computed as o, openBlock as m, createElementBlock as l, Fragment as B, renderList as k, renderSlot as E, createElementVNode as $, normalizeProps as C, guardReactiveProps as L, mergeProps as R } from "vue";
import { createCdnMediaUrl as I } from "@apility/netflex-cdn-url";
import { createCdnMediaUrl as X } from "@apility/netflex-cdn-url";
const w = Symbol("cdnImageInjection"), V = (n, { cdnUrl: r, breakpoints: i, pixelDensities: d = ["1x", "2x", "3x"], compressor: p }) => {
  n.use(D, { cdnUrl: r }), n.use(z, { breakpoints: i }), n.provide(w, { cdnUrl: r, breakpoints: i, pixelDensities: d, compressor: p });
}, A = () => {
  const n = S(w);
  if (n === void 0)
    throw new Error("Cdn image injection was not provided");
  return n;
}, M = { key: 0 }, O = ["srcset", "media"], q = /* @__PURE__ */ y({
  __name: "CdnImage",
  props: {
    responsive: { type: Boolean, default: !0 },
    path: {},
    mode: { default: "o" },
    size: {},
    parameter: {},
    pixelDensities: {},
    searchParams: {},
    breakpoints: {}
  },
  setup(n) {
    const r = n, {
      cdnUrl: i,
      breakpoints: d,
      pixelDensities: p,
      compressor: U
    } = A(), f = o(() => {
      var e;
      return {
        compressor: ((e = r.searchParams) == null ? void 0 : e.compressor) ?? U,
        ...r.searchParams
      };
    }), h = o(() => r.pixelDensities ?? p), g = (e, t = {}) => {
      const s = new URL(e);
      return Array.from(Object.entries(t)).forEach(([a, c]) => {
        c !== void 0 && s.searchParams.set(a, String(c));
      }), s;
    }, v = o(() => g(
      I(i, r.path, r.mode, r.size, r.parameter),
      f.value
    )), x = (e, t) => t.map((s) => {
      const a = new URL(e);
      return a.searchParams.set("res", s), `${a} ${s}`;
    }).join(", "), j = o(() => x(
      v.value,
      h.value
    )), _ = o(() => Object.entries(d).map(([e], t, s) => {
      var P;
      const [, a] = s[t + 1] ?? [];
      if (!a)
        return;
      const c = ((P = r.breakpoints) == null ? void 0 : P[e]) ?? {};
      return {
        path: r.path,
        mode: r.mode,
        size: r.size,
        parameter: r.parameter,
        pixelDensities: h.value,
        searchParams: f.value,
        ...c,
        width: a - 1
      };
    }).filter((e) => e !== void 0).map((e) => {
      const t = g(
        I(i, e.path, e.mode, e.size, e.parameter),
        e.searchParams
      );
      return t.searchParams.set("src", String(e.width)), {
        srcset: x(t, e.pixelDensities),
        media: `(max-width: ${e.width}px)`
      };
    })), u = o(() => ({
      src: v.value.toString(),
      srcset: j.value
    }));
    return (e, t) => e.responsive ? (m(), l("picture", M, [
      (m(!0), l(B, null, k(_.value, (s) => (m(), l("source", {
        srcset: s.srcset,
        media: s.media
      }, null, 8, O))), 256)),
      E(e.$slots, "default", { attrs: u.value }, () => [
        $("img", C(L(u.value)), null, 16)
      ])
    ])) : (m(), l("img", C(R({ key: 1 }, u.value)), null, 16));
  }
});
export {
  q as CdnImage,
  X as createCdnMediaUrl,
  V as netflexCdnImagePlugin,
  T as useBreakpoints,
  A as useCdnImage,
  J as useCdnUrl
};
